module.exports = __webpack_public_path__ + "assets/9340046c3362644d20f42435559a7c4f.mp3";